import React from 'react';
import PropTypes from 'prop-types';

import { Desktop, Mobile } from '@edreamsodigeo/frontend-core';
import { Box, Heading } from '@edreamsodigeo/prisma-design-system';

export const StepTitle = ({ children }) => {
  return (
    <>
      <Desktop>
        <Heading type="5" weight="medium" color="neutral.100">
          {children}
        </Heading>
      </Desktop>
      <Mobile>
        <Heading type="4" weight="medium" color="neutral.90">
          <Box pr="1x_small">{children}</Box>
        </Heading>
      </Mobile>
    </>
  );
};

StepTitle.propTypes = {
  children: PropTypes.node,
};
